import React, { memo, useState, useEffect, useCallback, useRef } from "react";
import { getFeedTabList, getWeather, getFeedList } from "@/api/home";

import styles from "./style.module.less";
import { Spin, Tabs } from "antd";
import ImgComps from "../../../ImgComps";
import Bus from "@/utils/bus";
import { Iprops } from "../..";
export interface feedItem {
  title: string | null; // 标题
  coverageUrl?: string | null; // 封面图url
  pcUrl: string | null;
  mobileUrl: string | null;
  authorHeadImgUrl?: string | null; // 作者头像
  authorName: string | null; // 作者名
}
export interface feedInterface {
  count: number; // 共多少条
  contentList: feedItem[];
}
const pageSize = 16;
const FeedTab = ({ onAppOrLinkClick, t }: Iprops) => {
  const [tabsData, setTabsData] = useState<any[]>([]);
  const [status, setStatus] = useState("loading");
  const [feedData, setFeedData] = useState<feedItem[]>([]);
  const pageNum = useRef(1);
  const hasMore = useRef(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    getFeedTabList().then((res: any) => {
      const data = res?.tabList.length > 0 ? [res?.tabList[0]] : [];
      // 获取banner设置
      setTabsData(
        data?.map((item) => {
          return {
            title: item.tabName,
            tabUrl: item.tabUrl
          };
        })
      );
    });
  }, []);
  useEffect(() => {
    Bus.on("home-scrollToBottom", doMoreClick);
    return () => {
      Bus.off("home-scrollToBottom", doMoreClick);
    };
  }, []);
  const getFeedData = () => {
    setStatus("loading");
    hasMore.current = false; // 加载中禁止再次加载
    getFeedList(pageNum.current, pageSize)
      .then((res: feedInterface) => {
        console.log(res, "getFeedList");
        setFeedData((pre) => {
          return pre.concat(res.contentList);
        });
        hasMore.current = res.count > pageNum.current * pageSize;
        setStatus(res.count > pageNum.current * pageSize ? "more" : "noMore");
      })
      .catch(() => {
        setFeedData([]);
        setStatus("noMore");
        hasMore.current = false;
      });
  };
  useEffect(() => {
    if (current === 0) {
      pageNum.current = 1;
      setFeedData([]);
      getFeedData();
    }
  }, [current]);
  const doMoreClick = () => {
    if (!hasMore.current) return;
    pageNum.current = pageNum.current + 1;
    getFeedData();
  };
  //   const doClickTab = (val) => {
  //     console.log(val, "val");
  //   };
  //   const onItemClick = (val) => {
  //     console.log(val, "val");
  //     onAppOrLinkClick(val);
  //   };
  return (
    <div className={styles.wrapper}>
      <Tabs activeKey={String(current)} className={`${styles.tab_wrap} custom_tab_ui`}>
        {tabsData.map((item: any, idx: number) => (
          <Tabs.TabPane key={idx} tab={item.title}>
            {current === 0 ? (
              <div className={styles.feed_wrapper_all}>
                <div className={styles.feed_wrapper}>
                  {feedData?.map((item: feedItem) => {
                    return (
                      <div
                        className={styles.item_wrapper}
                        onClick={() => {
                          onAppOrLinkClick({ ...item, urlType: 1 });
                        }}
                      >
                        <ImgComps className={styles.item_img} src={item.coverageUrl} />
                        <div className={styles.item_title}>{item.title}</div>
                        <div className={styles.item_bottom}>
                          <ImgComps className={styles.icon_user} src={item.authorHeadImgUrl} />
                          <span className={styles.user_name}>{item.authorName}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className={styles.loading_container}>
                  {status === "loading" && <Spin tip={t("homeIndex.loading")} spinning={true} />}
                  {status === "noMore" && (
                    <span className={styles.noMore}>{t("homeIndex.no-more")}</span>
                  )}
                  {status === "more" && (
                    <span className={styles.hasMore} onClick={doMoreClick}>
                      {t("homeIndex.more")}
                    </span>
                  )}
                </div>
              </div>
            ) : null}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default FeedTab;
